import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserStore } from '@app/store/user.store';
import { interval, map, Observable, of, switchMap, takeWhile } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeGuard implements CanActivate {
  userStore = inject(UserStore);

  constructor(private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return interval(100).pipe(
      switchMap(() => {
        const user = this.userStore.user();
        const loadUser = this.userStore.loadUser();

        if (!loadUser) {
          if (user && user.id !== -1 && user.admin) {
            return of(this.router.parseUrl('/admin'));
          } else if (user && user.id !== -1 && user.admin === false) {
            return of(true);
          } else {
            return of(this.router.parseUrl('/error'));
          }
        }
        return of(null);
      }),
      takeWhile((result) => result === null, true),
      map((result) => (result !== null ? result : false))
    );
  }
}
